export const BASE_AD_UNITS = {
  home: '/6782/GenAptTherapy/Home',
  category: '/6782/GenAptTherapy/Category',
  collection: '/6782/GenAptTherapy/Collection',
  post: '/6782/GenAptTherapy/Post',
  gallery: '/6782/GenAptTherapy/Gallery',
  author: '/6782/GenAptTherapy/Author',
  recipe: '/6782/GenAptTherapy/Recipe'
};

export const BASE_AD_UNITS_AMP = {
  post: '/6782/AMP_GenAptTherapy/AmpPost',
  gallery: '/6782/AMP_GenAptTherapy/AmpGallery'
};

export const MAX_SUB_UNIT_COUNT = 12;

export const RAIL_REFRESH_INTERVAL = 15;
